module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_3-01f6363f13bad49873eab93c30702968.gif";